import { Component, OnInit } from '@angular/core';
import { CurrentCaseService } from '@modules/common/services/current-case.service';
import { CurrentLoginStylingService } from '@modules/common/services/current-login-styling.service';
import { LoginClientLogoUrlService } from '@modules/common/services/login-client-logo-url.service';

@Component({
    selector: 'app-login-client-logo',
    templateUrl: './login-client-logo.component.html',
    styleUrls: ['./login-client-logo.component.scss']
})
export class LoginClientLogoComponent implements OnInit {
    public currentCase: string = '';
    public logoUrl: string = '';
    private static DEFAULT_LOGO_URL = 'https://media.winstonfinancial.com/Stingray/Images/HRally_logo_109x60.png';

    constructor(
        private _currentCaseService : CurrentCaseService,
        private _currentLoginStylingService: CurrentLoginStylingService,
        private _loginClientLogoUrlService: LoginClientLogoUrlService
    ) { }

    public ngOnInit(): void {
        this.currentCase = this._currentCaseService.getCurrentCaseName();

        this._currentLoginStylingService.configChanged.subscribe(result => {
            if (result && result.clientLogoVersion) {
                this.logoUrl = this._loginClientLogoUrlService.getUrl(result.clientLogoVersion);
            } else {
                this.logoUrl = LoginClientLogoComponent.DEFAULT_LOGO_URL;
            }
        });
    }
}
